frontApp.promoSlider = {
  name: 'promoSlider',
  description: 'promo slider',
  sliderEl: '.js-promo-slider',
  className: {
    buttonHide: 'buttons-is-hide',
  },
  init() {
    const sliders = document.querySelectorAll(this.sliderEl);

    function loadImg(lazyImgs) {
      lazyImgs.forEach((lazyImg) => {
        if (!!lazyImg.getAttribute('data-ll-status') || lazyImg.offsetParent === null) {
          return;
        }
        LazyLoad.load(lazyImg);
      });
    }

    if (sliders) {
      for (let i = 0; i < sliders.length; i++) {
        const slider = new Splide(sliders[i], {
          type: 'fade',
          rewind: true, // for fade loop
          perPage: 1,
          gap: 40,
          mediaQuery: 'min',
          pagination: false,
          autoplay: true,
          interval: 7000,
        });

        slider.on('visible', (slide) => {
          const lazyImgs = slide.slide.querySelectorAll('.js-promo-slider-img');
          loadImg(lazyImgs);
        });

        slider.on('resized', () => {
          const lazyImgs = slider.root.querySelectorAll('.splide__slide.is-active .js-promo-slider-img');
          loadImg(lazyImgs);
        });

        const toggleViewButtonsClass = (prev, next) => {
          const { arrows } = slider.Components.Elements;
          slider.root.classList.remove(this.className.buttonHide);
          arrows.style.display = '';
          if (prev.disabled && next.disabled) {
            slider.root.classList.add(this.className.buttonHide);
            setTimeout(() => {
              arrows.style.display = 'none';
            });
          }
        };

        slider.on('arrows:mounted', (prev, next) => {
          toggleViewButtonsClass(prev, next);
        });

        slider.on('arrows:updated', (prev, next) => {
          toggleViewButtonsClass(prev, next);
        });

        slider.mount();
      }
    }
  },
};
